export const RESET_DECK = 'deck/RESET_DECK'
export const UNDO = 'deck/UNDO'
export const REDO = 'deck/REDO'
export const DECK_ID_SUCCEEDED = 'deck/DECK_ID_SUCCEEDED'
export const DECK_PATCH_SUCCEEDED = 'deck/DECK_PATCH_SUCCEEDED'
export const SET_DECK_STATE = 'deck/SET_DECK_STATE'
export const MODIFY_CARD_MAP = 'deck/MODIFY_CARD_MAP'
